import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import useDebouncedCallback from 'utils/customHooks/useDebouncedCallback';

const AutoCompleteInput = ({
  label,
  onSearch,
  placeholder,
  onSelect,
  defaultValue,
  defaultOptions = [],
  isMulti = false,
  defaultOptionsValue = null,
  value = null,
  isDisabled = false,
  menuPlacement = 'auto'
}) => {

  const loadOptions = useDebouncedCallback((value, callback) => {
    onSearch(value).then((options) => callback(options));
  }, 1000);

  return (
    <div>
      {label && <Form.Label className="text-light">{label}</Form.Label>}
      <div title={placeholder}>
        <AsyncSelect
          cacheOptions
          defaultOptions={defaultOptions}
          defaultValue={defaultValue}
          defaultInputValue={defaultValue?.label}
          loadOptions={loadOptions}
          onChange={onSelect}
          placeholder={placeholder}
          classNamePrefix="search-autocomplete"
          isClearable
          isMulti={isMulti}
          isDisabled={isDisabled}
          menuPlacement={menuPlacement}
          maxMenuHeight={200}
          styles={{
            menu: (base) => ({ 
              ...base, 
              zIndex: 9999,
              position: 'absolute'
            })
          }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: 'neutral60',
            },
          })}
          value={value || defaultOptionsValue || defaultValue}
        />
      </div>
    </div>
  );
};

AutoCompleteInput.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  menuPlacement: PropTypes.string,
};

export default AutoCompleteInput;
